import Vue from "vue";

/* eslint-disable */
import VueApollo from "vue-apollo";
import { ApolloClient } from "apollo-client";
import { onError } from "apollo-link-error";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { split, ApolloLink } from "apollo-link";
import { WebSocketLink } from "apollo-link-ws";
import { getMainDefinition } from "apollo-utilities";

import enviroment from "./enviroment";
import router from "./router";
import store from "./store";

const PATH = {
  CUSTOMER: "customer",
  DASHBOARD: "dashboard",
  TO_DASHBOARD: [
    "/",
    "/login",
    "/register",
    "/forgot",
    "/reset",
    "/verify-email",
  ],
};
const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
  // console.log(graphQLErrors, networkError, operation);
  if (graphQLErrors) {
    for (const el of graphQLErrors) {
      if (
        el.extensions.code === "access-denied"
        // ||
        // el.extensions.code === "validation-failed"
      ) {
        console.log(el);

        localStorage.clear();
        location.reload();
        break;
      }
    }
  }
});
const authLink = new ApolloLink((operation, forward) => {
  // Retrieve the authorization token from local storage.
  let token: string;
  if (router) {
    // let currentPath = router.currentRoute.fullPath.split("/")[1];
    let currentPath = location.pathname.split("/")[1];
    if (currentPath === PATH.CUSTOMER) {
      token = localStorage.getItem("client_token") || "";
    }
    // if (
    //   currentPath === PATH.DASHBOARD ||
    //   PATH.TO_DASHBOARD.some((el) => el === location.pathname)
    // )
    else {
      token = localStorage.getItem("user_token") || "";
    }
  }

  // Use the setContext method to set the HTTP headers.
  operation.setContext({
    headers: {
      authorization: token ? `${token}` : "",
    },
  });

  // Call the next link in the middleware chain.
  return forward(operation);
});

// HTTP connection to the API
const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri: enviroment.apiHttp,
});

const wsLink = new WebSocketLink({
  uri: enviroment.apiWs,
  options: {
    reconnect: true,
    timeout: 30000,
  },
});

const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  authLink.concat(wsLink),
  authLink.concat(httpLink)
);

// Cache implementation
const cache = new InMemoryCache({
  addTypename: true,
});

// Create the apollo client
export const apolloClient = new ApolloClient({
  link: errorLink.concat(link),
  cache,
  defaultOptions: {
    // mutate: { errorPolicy: "all",  },
    // query: { errorPolicy: "all" },
    watchQuery: {
      errorPolicy: "all",
    },
  },
});

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  // errorHandler: globalErrorHandler,
});

export default apolloProvider;
/* eslint-enable */
